import React from 'react'; 
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, Tabs, message } from 'antd';
import { CloseOutlined, CreditCardOutlined, EditOutlined, FileAddOutlined, 
  FileZipOutlined, RollbackOutlined } from '@ant-design/icons'
import { LoadingComponent } from '../../utils/ui'
import { getNameAsset } from '../../components/adms/helper';
import IndividualData from '../../components/subject/IndividualData';
import { VocabsRepository, VocabsIndividual, ModelViews, RdfTriplet} from '../../redux';
import { DetailLinkScheme } from '../../components/adms/DetailLinkCard';
import ViewsProxy from '../models/ViewsProxy';
import { makeHashLastInURI, makeURI } from '../../utils/uriUtil';
import { getCountValue } from '../../virtuoso/helper';
import SelectProperty from '../../components/widgets/SelectProperty';
import { filterAddedPredicates } from '../helper';
import ExportIndividual from '../../components/export/ExportIndividual';

const ButtonGroup = Button.Group;
const { confirm } = Modal;
const { TabPane } = Tabs;

const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name => <p>{name}</p>)</span>;
}

/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title="Добавление свойства" cancelText="Отмена" okText="Ок" 
    onCancel={onCancelOperation} onOk={onFinishOperation} destroyOnHidden>
        <SelectProperty formRef={formRef} subjectIri={IRI} existing={existing} 
          factory={factory} lang={lang}/>
    </Modal>
}

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Детальная информация" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, dispaly: "none" }}>
        <DetailLinkScheme triplet={selected} factory={factory}/>
	  </Modal>
}

const decodeIRIParams = router =>{
  return (router && router.params && router.params.id)?decodeURIComponent(router.params.id):null;
}


/** Карточка элемента справочника. Отображаются данные по заданному IRI субъекта. */
class IndividualCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false, 			  //Флаг загрузки, карточки skos:ConceptScheme
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      adding: false,        //Флаг, для отображения далога добавления нового свойства
      exportCard: false,    //Флаг, для отображения далога c экспортом карточки
      views: false,         //Загружены представления содержимого актива
      activeKey: undefined, //Номер активной вкладки
      newPredicate: undefined, //Предикат, который выбран диалоге добавления нового свойства
      addedPredicates: [],  //Добавленные предикаты
    }
  }
   
  formRef = React.createRef();
    
  static getDerivedStateFromProps(props, state) {
    if ((decodeIRIParams(props.router)!=props.IRI)||(props.state=="empty") || !props.IRI){
      return {loaded: false, operation: "view", detail: undefined, adding: false, newPredicate:undefined, addedPredicates:[]};
    }
    if ((decodeIRIParams(props.router)==props.IRI)||(props.state=="loaded")){
        return { ...state, loaded: true}
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const IRI = decodeIRIParams(this.props.router);
    if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty")){
      Promise.all([
        this.props.onReload(VocabsIndividual, IRI),
        this.props.onReloadViews(ModelViews, IRI),
      ]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const IRI = decodeIRIParams(this.props.router);

    if (prevProps.values !== this.props.values && this.state.addedPredicates.length > 0) {
      const addedPredicates = filterAddedPredicates(
        this.state.addedPredicates,
        this.props.values
      );

      if (addedPredicates.length !== this.state.addedPredicates.length) {
        this.setState({ addedPredicates });
        return;
      }
    };

    if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
      this.props.onReload(VocabsIndividual, IRI).then( response => {
        this.props.onReloadViews(ModelViews, IRI).then(views => {
          const activeKey = (this.props.location && this.props.location.search && this.props.location.search.indexOf('view=')>0)? "3" : undefined;
          this.setState({views: true, activeKey});
        });
      });
    //Проверим, что добавленное свойство появилось в списке полученных свойств
    if (Array.isArray(this.state.addedPredicates) && this.state.addedPredicates.length>0){
      const addedPredicates = this.state.addedPredicates.filter(predicate => this.props.predicates.includes(predicate));
      if (addedPredicates.length>0)
        this.setState({addedPredicates: this.state.addedPredicates.filter(predicate => !addedPredicates.includes(predicate))});
    }
  }

  callbackSelectTab(key) {
    console.log(key);
    this.setState({activeKey: undefined});
  }
  
  onSelectOperation(e, operation) { 
    e.preventDefault();
    const { IRI, values, lang, factory, onDeleteElement, router} = this.props;
    if (operation=="delete"){
      confirm({ title: 'Удалить выбранный элемент', content: getNameAsset(values, lang), 
        okText: 'Да', okType: 'danger', cancelText: 'Нет',
        onOk() { 
            onDeleteElement(VocabsRepository, IRI)
            .then (result =>{
                console.log("onDeleteElement", result);
                message.success("Запись удалена.");
                if (router)
                    router.navigate("/vocabs");
            })
        },
        onCancel() {},
      });
      return;
    };
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({adding: true});
      return;
    };    
    if (operation == "view"){      
      this.setState({operation, addedPredicates: []});
      return;
    }
    if (operation == "back"){
      if (router)
        router.navigate(
          this.props.getBaseRoutePath
          ? this.props.getBaseRoutePath("vocabs") 
          : "/vocabs"
        );

      return;
    };
    if (operation == "export"){
      this.setState({exportCard: true});
      return;      
    }
    this.setState({operation});
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    //console.log("ConceptSchemeCard.js handlers(e, triplet, operation)", triplet, operation, (operation== "inScheme"));
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement){
      const subjectIRI = triplet?.object?.value;
      if (subjectIRI) {
        const url = `#/subject/${encodeURIComponent(subjectIRI)}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
      return;      
    };
    //   //В триплете приходит {predicat: {…}, object: {…}}
    //   this.props.onDetailElement(VocabsIndividual, catalog, triplet)
    //   .then (result =>{
    //     //console.log("handlers(e, triplet, operation)", result);
    //     this.setState({detail: triplet});
    // });
    if (operation== "delete"){
      const { addedPredicates } = this.state;
      if (addedPredicates.includes(triplet))
        this.setState({addedPredicates: addedPredicates.filter(predicate => predicate != triplet)});
    }
    if (operation== "inScheme" && this.props.onInScheme){
      const subjectIRI = triplet?.IRI?.value;
      if (subjectIRI) {
        const url = `#/subject/${encodeURIComponent(subjectIRI)}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
      return;      
    };
    //   //В триплете приходит {IRI: {…}, Label: {…}, level: 0, hasBroader: false, children: Array(0), …}
    //   this.props.onInScheme(VocabsIndividual, catalog, triplet.IRI.value)
    //   .then (result =>{
    //     //console.log("handlers(e, triplet, operation)", result);
    //     this.setState({detail: {object: triplet.IRI}});
    // });
    if (operation== "deleteConcept"){
      //В триплете приходит {IRI: {…}, Label: {…}, level: 0, hasBroader: false, children: Array(0), …}
      this.props.onRemoveConcept(VocabsRepository, triplet.IRI.value)
        .then (result =>{
            message.success("Концепт удалён");
            Promise.all([
              this.props.onReload(VocabsIndividual, this.props.IRI),
            ]);
        })
        .catch(info => {
          console.log("ConceptSchemeCard.js handlers() Received info of form: ", info);
          message.error("Ошибка удаление концепта");
        });
  
    }
  }

  cancelOperation(){
    this.setState({detail: undefined, adding: false, exportCard: false});
  }

  /** Вызывается при добавлении нового свойства. Данные см. AddProperty.js */
  submitAddProperty() {
    this.setState({detail: undefined, adding: false, operation: "edit"});
    const form  = this.formRef.current;
    form.validateFields()
     .then((values) => {
        const addedPredicates = [ ... this.state.addedPredicates, {object:{state: 'new'}, predicat : {type: 'uri', value: values.predicateIri}}];
        this.setState({detail: undefined, adding: false, operation: "edit", addedPredicates});
    }).catch((errorInfo) => {
      console.log(errorInfo);
    });
  };
  /** Запускает добавление нового  
   * элемента и установка связи */
  submitNewOperation() {
    const { IRI, onAddConcept, onInsertURI, onInsertLiteral} = this.props;
    //console.log('ConceptSchemeCard.js submitNewOperation() ', this.formRef);
    const form  = this.formRef.current;      
    form.validateFields()
      .then( values => {
        const concept = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://")) 
          ? values.IRI
          : makeURI(makeHashLastInURI(IRI), values.IRI);      
        //Проверим, что IRI отсутствует
        RdfTriplet.countSubject(concept)
        .then ( response =>{
          const count = getCountValue(response.bindings);
          if (count>0){
            message.error(`URI ${concept} уже существует. Задайте другой идентификатор.`);
            return;
          };
          const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
          const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
          const definition = values["http://www.w3.org/2004/02/skos/core#definition"];
          console.log("ConceptSchemeCard.js submitNewOperation() result2 ", IRI, concept, rdfType, label);
          onAddConcept(VocabsRepository, IRI, concept, rdfType, label.text)
            .then (result =>{
              const requests = [];
              if (values["new.flag.boolean"])
                requests.push(onInsertURI(RdfTriplet, IRI, "http://www.w3.org/2004/02/skos/core#topConceptOf", concept));
              if (values["new.select.uri"])
                requests.push(onInsertURI(RdfTriplet, concept, "http://www.w3.org/2004/02/skos/core#broader", values["new.select.uri"]));
              if (definition && definition != "")
                requests.push(onInsertLiteral(RdfTriplet, concept, "http://www.w3.org/2004/02/skos/core#definition", definition));
              Promise.all(requests)
                .then(result2 => {
                  //console.log("ConceptSchemeCard.js submitNewOperation() result2 ", result2);
                  message.success(i18n.t('skos.concept.message.ok_new'));
                  Promise.all([
                    this.props.onReload(VocabsIndividual, IRI),
                  ]);
              });
            })
            .catch(info => {
               message.error(i18n.t('skos.concept.message.e_new', {detail: info}));
            });
            this.setState({detail: undefined, adding: false, exportCard: false});
          });
      })
      .catch(info => {
        console.log("ConceptSchemeCard.js submitNewOperation() Received info of form: ", info);
        message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
      });
  };

  onReload(){
    this.props.onReload(VocabsIndividual, this.props.IRI);
  }

  render() {
    let { loaded, operation, detail, adding, activeKey, addedPredicates, exportCard} = this.state;
    const { predicates, values, lang, factory, IRI, vviews, isSignedIn, inGroup, concepts} = this.props;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    //console.log(this); //console.log(lang);
    const assetTitle = AssetTitle(getNameAsset(values, lang));
    return (
      (!loaded? <LoadingComponent />:
        <span>
          <Row>
            <Col className="asset_title" span={24}>{assetTitle}</Col>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={(key)=>this.callbackSelectTab(key)} type="card">
              <TabPane tab={i18n.t('views.adms.card_tab_card')} key="1">
                <div className="csi_wrapper_content csi_inner_asset" resource={IRI}>
                    <Row>
                      <Col className="asset_title" span={2} style={{"display": "flex", minWidth: "0px"}}>
                        <Tooltip placement="top" title={"Вернуться в список объектов"}>
                          <Button type="dashed" icon={<RollbackOutlined />} onClick={(e)=> this.onSelectOperation(e, "back")}/>
                        </Tooltip>                                          
                      </Col>
                      <Col className="asset_title" span={14} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                          {isSignedIn && inGroup.PowerUser && (
                            <ButtonGroup>
                              <Tooltip placement="top" title={i18n.t('views.adms.export_card')}>
                                <Button icon={<FileZipOutlined />} onClick={(e)=> this.onSelectOperation(e, "export")}/>
                              </Tooltip>                              
                              &nbsp;&nbsp;
                              {operation!="view" && (
                                <>
                                  <Tooltip placement="top" title={"Добавление свойства"}>
                                      <Button icon={<FileAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "add")}/>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={"Режим просмотра данных"}>
                                    <Button type="primary" icon={<CreditCardOutlined />} onClick={(e)=> this.onSelectOperation(e, "view")} />
                                  </Tooltip>
                                </>
                              )}
                              {operation!="edit" && (
                                <Tooltip placement="top" title={"Режим редактирования"}>
                                    <Button type="primary" icon={<EditOutlined />} onClick={(e)=> this.onSelectOperation(e, "edit")}/>
                                </Tooltip>
                              )}
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={"Удалить объекта из реестра"}>
                                <Button icon={<CloseOutlined />} onClick={(e)=> this.onSelectOperation(e, "delete")}/>
                              </Tooltip>                              
                            </ButtonGroup>
                          )}
                        </Col>
                        <Col className="asset_title" span={8}>
                        </Col>
                    </Row>
                    <Row id="IndividualData">
                        <Col className="assetCardTable" span={16}>
                          <IndividualData
                            addedPredicates={addedPredicates} operation={operation} factory={factory} 
                            handlers={(e,t,o)=> this.handlers(e,t,o)} onReload={() => this.onReload()}
                            getBaseRoutePath={this.props.getBaseRoutePath} /> 
                        </Col>
                    </Row>
                  {adding && 
                    showAddProperty(this.formRef, IRI, [...predicates, ...addedPredicates], factory, lang, 
                      ()=>this.submitAddProperty(), ()=>this.cancelOperation())
                  }
                  {detail && 
                    showViewDetail(this.formRef, detail, factory, ()=>this.cancelOperation(), ()=>this.cancelOperation())
                  }
                  { exportCard && <ExportIndividual open={true} onClose={()=> this.cancelOperation()} IRI={IRI}/>}
                </div>            
        </TabPane>
        {/* {views && (<TabPane tab={i18n.t('views.adms.card_tab_content')} key="3">
            <ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={view} location={this.props.location}/>
          </TabPane>)} */}
      </Tabs>
      </Row>
      </span>
      )
    )
  }
}

export default IndividualCard;